export enum PlasticDishesFields {
  type = "type",
  size = "size",
  otherSize = "otherSize",
  mainColor = "mainColor",
  numberOfPrintColors = "numberOfPrintColors",
  designFile = "designFile",
  amountPcs = "amountPcs",
}
